module.exports = __webpack_public_path__ + "media/images/people-3fae633c09987610cf1cee6623410f47.jpg";